import React from 'react';
import { createStyles, makeStyles, Theme } from '@material-ui/core';
import clsx from 'clsx';
import {
  BlackHeadings,
  DividersAndCardBorders,
  LightGray,
} from '../../../theme/colors';
import { GettingStartedUtils } from '../../../utils';
import { OnBoardingTask } from '../../../store/user/types';
import Button from '../../Button';
import { typography15MediumStyle } from '../../Text';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    flexContainer: {
      display: 'flex',
      [theme.breakpoints.down('sm')]: {
        flexDirection: 'column',
      },
    },
    tasksButtons: {
      boxSizing: 'border-box',
      minWidth: 250,
      borderRight: `1px solid ${DividersAndCardBorders}`,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      gap: theme.spacing(4),
      padding: theme.spacing(4, 3),
      [theme.breakpoints.down('sm')]: {
        borderRight: 'none',
        borderBottom: `1px solid ${DividersAndCardBorders}`,
      },
    },
    taskButton: {
      color: LightGray,
      ...typography15MediumStyle,
      '&:hover': {
        backgroundColor: 'white',
      },
    },
    taskDone: {
      textDecoration: 'line-through',
      '&:hover': {
        backgroundColor: 'white',
      },
    },
    active: {
      color: BlackHeadings,
    },
  }),
);

interface TasksListProps {
  tasks: Array<OnBoardingTask>;
  activeTaskCode: string;
  onSelect: (taskCode: string) => void;
}
export const TasksList: React.FC<TasksListProps> = ({
  tasks,
  activeTaskCode,
  onSelect,
}) => {
  const classes = useStyles();

  return (
    <div className={classes.tasksButtons}>
      {tasks.map(task => (
        <Button
          className={clsx(classes.taskButton, {
            [classes.taskDone]: task.fields.done,
            [classes.active]: task.fields.taskCode === activeTaskCode,
          })}
          htmlId={task.fields.taskCode}
          variant="text"
          disabled={task.fields.done}
          onClick={() => onSelect(task.fields.taskCode)}
          key={task.fields.taskCode}
        >
          {
            GettingStartedUtils.MapTaskCodeToTaskDetails(task.fields.taskCode)
              .title
          }
        </Button>
      ))}
    </div>
  );
};
